import { Text, useDisclosure } from "@chakra-ui/react";
import { Avatar } from "@chakra-ui/avatar";
import { Box, Flex } from "@chakra-ui/layout";
import { AssuntoMensagem, MensagemItem } from "core/features/mensagens/typings";
import React from "react";
import { formatDateOntemHoje } from "infra/helpers/formatDateOntemHoje";
import moment from "moment";
import { useMensagemModal } from "ui/components/DrawerNovaMensagem/MensagemModalContext";
import OutlineButton from "ui/components/Button/OutlineButton";
import { FaShare } from "react-icons/fa";
import colors from "core/resources/theme/colors";
import { TipoDestinoEnum } from "core/features/documentos/enums";
import LerMensagemModal from "../LerMensagemModal";

function CardMensagem({
  mensagem,
  unidadeId,
}: {
  mensagem: Partial<MensagemItem>;
  unidadeId: string;
}) {
  const { isOpen, onClose, onOpen } = useDisclosure();
  const { openWithDefaultValues } = useMensagemModal();
  const onReply = () =>
    openWithDefaultValues({
      tipoDestinoId: TipoDestinoEnum.UmaUnidade,
      destinos: [
        {
          destinoId: unidadeId,
          label: "Essa unidade",
          tipoDestinoId: TipoDestinoEnum.UmaUnidade,
        },
      ],
      mensagemRespostaId: mensagem.id!,
      assuntoId: AssuntoMensagem.Outros,
    });
  return (
    <Flex
      gridGap={2}
      borderBottomWidth={1}
      borderBottomColor={colors.black700}
      pt={2}
      pb={4}
      w="100%"
      mb={4}
    >
      <LerMensagemModal
        isOpen={isOpen}
        onClose={onClose}
        mensagem={mensagem}
        onReply={onReply}
      />
      <Avatar
        src={mensagem.imagemUrl || undefined}
        name={mensagem.autor}
        w="36px"
        h="36px"
      />
      <Flex flexDir="column" flexGrow={1}>
        <Flex>
          <Text fontWeight="bold" fontSize={14}>
            {mensagem.autor}
          </Text>
          <Text fontWeight="light" fontSize={12} ml="auto">
            {formatDateOntemHoje(mensagem.createdAt!)} às{" "}
            {moment(mensagem.createdAt!).format("HH:mm")}
          </Text>
        </Flex>
        <Box position="relative" cursor={"pointer"} onClick={onOpen}>
          <Text
            fontSize={13}
            maxH={"5rem"}
            overflow="hidden"
            my={2}
            dangerouslySetInnerHTML={{ __html: mensagem.conteudo || "" }}
          />
          <Text
            position={"absolute"}
            fontWeight="bold"
            bottom={1}
            pl={2}
            right={0}
            bg={"white"}
          >
            ... Clique para ler mais
          </Text>
        </Box>

        <OutlineButton
          h="32px"
          py={0}
          fontSize={12}
          lineColor={colors.primary}
          ml="auto"
          mt={2}
          onClick={onReply}
        >
          <Box as="span" transform="scaleX(-1)" mr={2}>
            <FaShare size={12} />
          </Box>
          Responder
        </OutlineButton>
      </Flex>
    </Flex>
  );
}

export default CardMensagem;
